module.exports = __webpack_public_path__ + "media/home/financial-times-7c3c0eb3.png";